import { getWindowObject } from '@eventbrite/feature-detection';

type PostMessage = {
    messageName: string;
    widgetParentUrl?: string;
    eventId?: string;
    additionalData?: object;
};

export const postMessage = ({
    messageName,
    eventId,
    widgetParentUrl,
    additionalData = {},
}: PostMessage): Promise<void> => {
    // You would only not have a widgetParentUrl if you access /checkout-external directly,
    // which sometimes we want to do for testing
    if (widgetParentUrl) {
        getWindowObject('parent')?.postMessage(
            {
                ...additionalData,
                messageName,
                eventId,
            },
            widgetParentUrl,
        );
    }

    return Promise.resolve();
};
